import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import axios from '../../../utils/axios';
import { FetchAndroidMessageApp } from './fetch-android-message-app';

export namespace RemoveAndroidMessageApp {
  export type RequestType = {
    androidMessageAppId: number;
  };

  export const useMutate = ({
    onSuccess,
    ...options
  }: UseMutationOptions<AxiosResponse, AxiosError, RequestType> = {}) => {
    const { refetch } = FetchAndroidMessageApp.useRefetchData();

    const mutation = useMutation(
      ({ androidMessageAppId }) => {
        return axios.delete(`/android/message-app/${androidMessageAppId}`);
      },
      {
        onSuccess: (...rest) => {
          refetch();
          onSuccess?.(...rest);
        },
        ...options
      }
    );

    return mutation;
  };
}
